//导入上传的api
import {
  uploadImportCompany,
  importEnterpriseTycCompany
} from "@/api/enterprise";
import { uploadImportProjectData } from "@/api/numberProject";
import { uploadImportCase } from "@/api/caseData";
import { uploadProduct } from "@/api/product";
import { uploadScheme } from "@/api/scheme";
import { addIndustry } from "@/api/industry";
import { technology } from "@/api/technology";
import { importActivity } from "@/api/activity";
import { field } from "@/api/field";
//policyImportProject 政策数据
import { importExcelV1 } from "@/api/policy";
import { uploadInfo } from "@/api/paper";
import { importExcel } from "@/api/recruit.js";
import { importCommercial } from "@/api/commercial.js";
import { importClientEnterprise, importTycCompany } from "@/api/customCompany";
import { importExcelZj } from "@/api/expert";
import { importdata } from "@/api/technology";
import { uploadReportData } from "@/api/report.js";
import { importData } from "@/api/productClassify.js";

import {
  importCountryStandard,
  importBehaviorStandard,
  importLocalStandard,
  importCompanyStandard,
  importTeamStandard,
  importInternationalStandard,
  importForeignStandard
} from "@/api/standardKnowledge";
//getKnowTechList  getKnowFieldList getDicRadioButton
import { getIndustryList, clientEnterprise } from "@/api/common";

//专利数据本地导入
import { patentLoaclUploadaApi } from "@/api/equity.js";
//研究报告本地数据批量导入
import { researchReportLoaclUploadaApi } from "@/api/report.js";
import { industryLoaclUploadaApi } from "@/api/technology.js";

//api整合
export const API = {
  uploadImportCompany,
  clientEnterprise,
  uploadImportProjectData,
  uploadReportData,
  uploadProduct,
  importExcel,
  uploadImportCase,
  technology,
  field,
  importTycCompany,
  importActivity,
  importExcelV1,
  uploadScheme,
  importClientEnterprise,
  importExcelZj,
  importCountryStandard,
  importBehaviorStandard,
  importLocalStandard,
  importTeamStandard,
  importCompanyStandard,
  importInternationalStandard,
  importForeignStandard,
  uploadInfo,
  importCommercial,
  importdata,
  importEnterpriseTycCompany,
  importData,
  addIndustry,

  patentLoaclUploadaApi,
  researchReportLoaclUploadaApi,
  industryLoaclUploadaApi
};
//各类型导入对应接口名称
export const importFileInterfaceMap = {
  企业数据: "uploadImportCompany",
  本地导入: "clientEnterprise",
  项目数据: "uploadImportProjectData",
  报告数据: "uploadReportData",
  产品数据: "uploadProduct",
  招聘数据: "importExcel",
  案例数据: "uploadImportCase",
  技术知识: "technology",
  领域知识: "field",
  智参企业: "clientEnterprise",
  活动数据: "importActivity",
  政策数据: "importExcelV1",
  方案拆解: "uploadScheme",
  客户企业: "importClientEnterprise",
  专家数据: "importExcelZj",
  国家标准数据: "importCountryStandard",
  行业标准数据: "importBehaviorStandard",
  地方标准数据: "importLocalStandard",
  团体标准数据: "importTeamStandard",
  企业标准数据: "importCompanyStandard",
  国际标准数据: "importInternationalStandard",
  国外标准数据: "importForeignStandard",
  论文数据: "uploadInfo",
  政府数据: "importCommercial",
  场景知识: "importdata",
  数智企业: "importEnterpriseTycCompany",
  产品类别: "importData",
  行业知识: "addIndustry",

  专利数据: "patentLoaclUploadaApi",
  研究报告: "researchReportLoaclUploadaApi",
  行业数据: "industryLoaclUploadaApi",
};

import { getPatentInformation } from "@/api/equity.js"; //天眼查

//天眼查api整合
export const tianyanAPI = {
  getPatentInformation,
  importTycCompany,
  importEnterpriseTycCompany
};

//天眼查各类型导入对应接口名称
export const importTianyanMap = {
  专利数据: "getPatentInformation",
  智参企业: "importTycCompany",
  服务商企业:"importEnterpriseTycCompany"
};

//有模板的类型
export const templateTypes = [
  "专利数据",
  "案例数据",
  "行业场景",
  "活动数据",
  "政策数据",
  "智参企业",
  "人才数据",
  "服务商企业"
];
